import { fetchRequestSend } from "../../helpers/common-helpers";
import { checkCoverImageIsExist } from "./Main";
import CatalogNavigationClass from "./CatalogNavigationClass";
import l10n from "../../lang/locallang";

/**
 * Class responsible for handling catalog search functionality.
 */
export default class CatalogSearchClass {
    /**
     * Constructor initializes the class and sets up event listeners.
     */
    constructor() {
        /** @type {string} Stores the initial HTML content of the catalog list. */
        this.topicHtml = "";

        /** @type {HTMLElement | null} The search input element. */
        this.input = document.querySelector("#courses-search");

        /** @type {HTMLElement | null} The wrapper element for catalog or QR list. */
        this.wrapper = document.querySelector("#catalog-list") || document.querySelector("#qr-list");

        /** @type {HTMLElement | null} The main bar element where no-match messages appear. */
        this.mainbar = document.querySelector(".mainbar");

        this.initialize();
    }

    /**
     * Initializes the search functionality by caching HTML content and setting up event listeners.
     */
    initialize() {
        if (this.wrapper) {
            this.topicHtml = this.wrapper.innerHTML;
        }
        if (this.input) {
            this.attachEventListeners();
        }
    }

    /**
     * Attaches event listeners to the search input.
     */
    attachEventListeners() {
        this.input.addEventListener("keyup", (e) => this.handleKeyUp(e));
    }

    /**
     * Handles the keyup event in the search input.
     * @param {KeyboardEvent} e - The keyup event object.
     */
    handleKeyUp(e) {
        const { quickReferences, courses, topics } = l10n.catalog;
        const filter = e.target.value.trim();

        this.clearNoMatchElements();

        if (!this.wrapper) return;

        if (filter) {
            this.updateTitle(this.wrapper.id === "qr-list" ? quickReferences : courses);
            this.searchCourses(filter);
        } else {
            this.updateTitle(topics);
            this.wrapper.innerHTML = this.topicHtml;
        }
    }

    /**
     * Removes existing "no-match" elements to prevent duplication.
     */
    clearNoMatchElements() {
        document.querySelectorAll(".mainbar .no-match").forEach(element => element.remove());
    }

    /**
     * Updates the title displayed in the title box.
     * @param {string} title - The new title to be displayed.
     */
    updateTitle(title) {
        const titleBox = document.querySelector(".title-box h2");
        if (titleBox) titleBox.innerText = title;
    }

    /**
     * Performs a search request and updates the results.
     * @param {string} filter - The search query entered by the user.
     */
    searchCourses(filter) {
        let url = typeof getCourseSearch !== "undefined" ? getCourseSearch : "";
        if (this.wrapper.id === "qr-list") url = searchQrUrl;

        const comingSoonCheckbox = document.querySelector("#coming_soon");
        const comingSoonStatus = comingSoonCheckbox?.checked ? "true" : "false";

        const json = { search_query: filter, coming_soon: comingSoonStatus };
        this.wrapper.style.opacity = "0";

        fetchRequestSend(url, "POST", json).then(response => {
            this.wrapper.innerHTML = "";
            if (response.response?.length > 0) {
                new CatalogNavigationClass().renderTiles(response.response, this.wrapper.id, "topic", true, response);
            } else {
                this.displayNoMatchMessage();
            }
        }).finally(() => {
            setTimeout(() => { this.wrapper.style.opacity = "1"; }, 50);
        });
    }

    /**
     * Displays a "no matching record found" message if the search returns no results.
     */
    displayNoMatchMessage() {
        if (this.mainbar?.querySelector(".no-match")) return; // Prevent duplicate no-match messages

        const { noMatchingRecordFound } = l10n.catalog;
        const newElement = document.createElement("span");
        newElement.className = "no-match";
        newElement.textContent = `${noMatchingRecordFound}!`;
        this.mainbar.appendChild(newElement);
    }
}
